export const COUNTRY_LANGUAGE_MAP: { [key: string]: string } = {
    'GB': 'en',
    'FR': 'fr',
    'ES': 'es',
    'DE': 'de',
    'CN': 'zh',
    'IT': 'it',
    'PT': 'pt',
    'NL': 'nl',
    'RU': 'ru'
}